<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
            d="M5.07 17.5A8 8 0 1 1 18.93 17.5"
            fill="transparent"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12 13.5L16.1 9.4"
            fill="transparent"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <circle cx="12" cy="13.5" r="1.1" fill="currentColor" />
    </svg>
</template>
